import con from '../../../../connection';
var path = '/confirmed';
var confirmed = function (url) { return function (planId, applicationId) { return ({
    post: function () { return con.post(url + '/' + planId + '/' + applicationId + path, {}); },
}); }; };
export default confirmed;
